import React, { useEffect } from 'react'
import { StyleSheet, View, ActivityIndicator } from 'react-native'


import {
  Title,
  Space,
  Spinner,
  AnimatedLoadingPulsingView
} from '@sart/components'
import { useContent } from '@sart/content'
import client, { orderHelper } from '@sart/client'
import ApiClient from "../bff-client/src/ApiClient";
import OrdersApi from '../bff-client/src/api/OrdersApi'
import AppConfig from '../Configuration/AppConfig';

import { CompanyIcon } from '@sart/icons'
import { colors } from '@sart/styles'
import delay from 'delay';


export default function CheckoutProcessing(props) {
  const content = useContent();

  const { navigation, route } = props
  console.log('Props is: ' + JSON.stringify(props, null, 2))
  const basketRefId = route.params?.basketRefId
  const passedPaymentStatus = route.params?.paymentStatus
  console.log('Basket ref id is: ' + basketRefId)

  const bffClient = new ApiClient(AppConfig.bffBasePath)
  bffClient.defaultHeaders = {
    ...bffClient.defaultHeaders,
    Origin: AppConfig.shopOriginUrl
  }
  console.log('bff client default headers: ' + JSON.stringify(bffClient.defaultHeaders, null, 2))
  const ordersApi = new OrdersApi(bffClient)




  useEffect(() => {
    if (passedPaymentStatus === 'cancel') {
      navigation.goBack();
      return;
    }
    checkPaymentStatus()
  }, [])

  async function checkPaymentStatus() {
    console.log('waiting for 5 seconds first')
    await delay(5000)
    console.log('BFF - trying to get order with basket ref id: ' + basketRefId)
    let order = await ordersApi.ordersGet(basketRefId)
    console.log('BFF - Got order: ' + JSON.stringify(order, null, 2))
    // let order = await client.getOrder(basketRefId)

    // if (!order) {
    //   //we need to try again a couple of times to see if we can get the order
    //   for (let i = 0; i < 5; i++) {
    //     await delay(2000)
    //     order = await client.getOrder(basketRefId)
    //     if (order) {
    //       break
    //     }
    //   }
    // }

    // if (order && order.status !== 'successful' && order.status !== 'failed') {
    //   order = await client.pollOrderForStatus(client.cache.customerId, order.orderId)
    // }
    // console.log('Got order: ' + JSON.stringify(order, null, 2))
    if (order && order.status === 'successful') {
      const product = order.serviceAddItems?.[0]?.product

      const confirmationText = 'Thank you for your purchase of our ' + product?.productName + '. This should reflect on your account shortly.'
      const params = {
        confirmation: {
          title: 'Purchase Successful',
          description: confirmationText,
          status: 'successful'
        }
      }

      navigation.navigate('Confirmation', params)
    } else if (order && order.status === 'failed') {
      const params = {
        confirmation: {
          title: 'Purchase Failed',
          description: 'There was a problem processing your purchase and a refund has been issued. Please try again or contact support if the issue persists.',
          status: 'failed'
        }
      }
      navigation.navigate('Confirmation', params)
    }
  }

  //OLD IMPLEMENTATION FOR DEV REFERENCE
  // async function checkPaymentStatus(){
  //   let order = route.params?.order
  //   order = await orderHelper.pollOrderForStatus(client.cache.customerId, order.orderId)

  //   if (order && order.status === 'successful') {
  //     const productsPurchased = route.params?.productsPurchased
  //     client.loadBalancesAndInvoices(client.cache.accounts[0])
  //     navigation.navigate('Confirmation', {
  //       productsPurchased,
  //       order
  //     })
  //   } else if (order && order.status === 'failed') {
  //     navigation.navigate('Checkout', {
  //       failedOrder: order
  //     })
  //   } else {
  //     console.log('purchase has failed');
  //   }
  // }

  return (
    <View style={styles.container}>
      <Space height={24} />
      <ActivityIndicator size="large" color={colors.brightOrange} />
      <Space height={2 * 24} />

      <Title style={styles.title}>
        {content.common.processing}
      </Title>

    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.darkCharcoal,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24
  },
  title: {
    color: colors.white,
    fontSize: 24
  },
})
